import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import GA from 'services/gaService'
import { Button, Container, Stack, Typography } from '@mui/material'
import { path } from 'ramda'
import { useVerifyUserMutation } from 'api/userApi'
import { useAnalytics, useLocalStorage } from 'hooks'
import { setUserData } from 'store/userSlice'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import SuccessMessage from 'components/common/SuccessMessage'
import Revalidate from './Revalidate'

const Verify = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { token } = useParams()
  const [search] = useSearchParams()
  const email = search.get('email')

  const { sendEvent } = useAnalytics()
  const { clear, save } = useLocalStorage()

  const [submitVerify, { data, isError, isSuccess }] = useVerifyUserMutation()

  useEffect(() => {
    if (isSuccess) {
      const sessionId = path(['headers', 'headers'], data).get('X-Session-Id')
      save(sessionId)
      // set the user in the context so that we get correct header behavior
      dispatch(setUserData(path(['res', 'user'], data)))
      sendEvent('pending_user_click', {})
      navigate('/onboarding/introduction')
    }
  }, [data, isSuccess])

  const renderContent = () => {
    if (isSuccess) {
      return (
        <SuccessMessage
          hasSuccess
          message={
            <FormattedMessage
              defaultMessage="Success! Check your email to verify your new account."
              id="MGQUIN"
            />
          }
        />
      )
    }

    if (isError) {
      return <Revalidate />
    }

    return (
      <>
        <Typography fontFamily="mark-ot" textAlign="center" variant="h4">
          <FormattedMessage
            defaultMessage="Click the button below to verify your account and log in."
            id="LSuAiY"
          />
        </Typography>
        <Button
          onClick={() => {
            GA.click('Verify-Email-Submit', 'Click')
            clear()
            submitVerify({ email, token })
          }}
        >
          <FormattedMessage defaultMessage="Verify" id="q5Xl0M" />
        </Button>
      </>
    )
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Stack alignItems="center" spacing={3}>
        <Typography variant="h1">
          <FormattedMessage defaultMessage="Verify your email" id="lBs6BA" />
        </Typography>
        {renderContent()}
      </Stack>
    </Container>
  )
}

export default Verify
